import { useMutation } from '@tanstack/react-query';
import {
  type ForgotPasswordDto,
  type SignupDto,
  type SigninDto,
  type SocialAuthDtoProviderEnum,
  type ResetPasswordDto,
} from '@unreserved/sdk';
import { authenticationApi } from '@unreserved/services/sdk-client';

export const useLogin = () => {
  const loginMutation = useMutation({
    mutationFn: (loginData: SigninDto) => {
      return authenticationApi.authControllerSigninV1({
        signinDto: loginData,
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });
  return { loginMutation };
};

export const useSignup = () => {
  const signupMutation = useMutation({
    mutationFn: (signupData: SignupDto) => {
      return authenticationApi.authControllerSignupV1({
        signupDto: signupData,
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });

  return { signupMutation };
};

export const useGetSocialAuthUrl = () => {
  const getSocialAuthUrlMutation = useMutation({
    mutationFn: ({
      provider,
      redirectUri,
    }: {
      provider: SocialAuthDtoProviderEnum;
      redirectUri?: string;
    }) => {
      return authenticationApi.authControllerGetSocialAuthUrlV1({
        socialAuthDto: { provider, redirectUri },
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });
  return { getSocialAuthUrlMutation };
};

export const useResetPassword = () => {
  const resetPasswordMutation = useMutation({
    mutationFn: (resetPasswordData: ResetPasswordDto) => {
      return authenticationApi.authControllerResetPasswordV1({
        resetPasswordDto: resetPasswordData,
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });
  return { resetPasswordMutation };
};

export const useForgotPassword = () => {
  const forgotPasswordMutation = useMutation({
    mutationFn: (forgotPasswordData: ForgotPasswordDto) => {
      return authenticationApi.authControllerForgotPasswordV1({
        forgotPasswordDto: forgotPasswordData,
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });
  return { forgotPasswordMutation };
};

export const useLogout = () => {
  const logoutMutation = useMutation({
    mutationFn: (deviceId: string) => {
      return authenticationApi.authControllerLogoutV1({
        logoutDto: { deviceId },
      });
    },
    onSuccess: async () => {},
    onError: async () => {},
  });
  return { logoutMutation };
};
